import { Separator, HStack, Text, VStack } from "@chakra-ui/react";
import { useMemo } from "react";
import { observer } from "mobx-react";
import { t } from "i18next";
import { countFilledProperties } from "../../../../../shared/utils/object-utils";
import { useStores } from "../../../../../shared/stores/RootStore";

const i18prefix = "map:nodeSummary.info";

const SelectedNodeInfoBase: React.FC = () => {
  const { codingStore, craNodeStore } = useStores();
  const node = craNodeStore.getSelected()!;

  const nodesCodedRatio = useMemo(() => {
    if (node) {
      const nodeAttributes = codingStore.getFromSelectedNode();
      if (nodeAttributes) {
        const nFilledAttributes = countFilledProperties(
          nodeAttributes.attributes,
        );
        return t("coding:session.codedRatio", {
          nCoded: nFilledAttributes.filled,
          totalNodes: nFilledAttributes.total,
        });
      }
    }
    // eslint-disable-next-line
  }, [node]);

  if (!node) return null;

  return (
    <VStack gap={4} alignItems="left" fontSize="sm">
      <HorizontalItem
        label={t(`${i18prefix}.dateTime`)}
        value={new Date(node.dateTime).toLocaleString()}
      />

      {!!nodesCodedRatio && (
        <HorizontalItem
          label={t(`${i18prefix}.codedNode.label`)}
          value={nodesCodedRatio || ""}
        />
      )}

      <div>
        <HorizontalItem
          label={t(`${i18prefix}.nodeLength.label`)}
          value={
            node?.distanceToNext
              ? `${node.distanceToNext.toFixed(2)}${t(
                  `${i18prefix}.nodeLength.distanceUnit`,
                )}`
              : "-"
          }
        />

        <HorizontalItem
          label={t(`${i18prefix}.distanceFromStart.label`)}
          value={
            node?.distanceToNext
              ? `${node.distanceFromStart.toFixed(2)}${t(
                  `${i18prefix}.distanceFromStart.distanceUnit`,
                )}`
              : "-"
          }
        />
      </div>

      <div>
        <HorizontalItem
          label={t(`${i18prefix}.coordinates.lat`)}
          value={node.latitude}
        />
        <HorizontalItem
          label={t(`${i18prefix}.coordinates.lng`)}
          value={node.longitude}
        />
      </div>
    </VStack>
  );
};

export const SelectedNodeInfo = observer(SelectedNodeInfoBase);

const HorizontalItem: React.FC<{ label: string; value: any }> = ({
  label,
  value,
}) => (
  <HStack>
    <Text flexShrink={0}>{label}</Text>
    <Separator flexGrow={1} orientation="horizontal" />
    <Text flexShrink={0} fontWeight="semibold">
      {value}
    </Text>
  </HStack>
);
